<div id="{{vm.item.Id}}" ng-class="{selected: vm.item.selected, 'not-selected': !vm.item.selected}"
     ng-mouseup="treeCtrl.mouseUp($event, vm.item)"
     ng-mousemove="treeCtrl.mouseMoveItem($event, vm.item)"
     ng-click="treeCtrl.toggle(vm.item)">

    <div class="move-column"  ng-if="treeCtrl.usePosition" ng-mousedown="treeCtrl.mouseDown($event, vm.item)">
        <i class="fa fa-arrows"></i>
    </div>
    <div class="language-column"
         ng-repeat="localization in vm.item.Text.Localizations | filter: treeCtrl.arrayFilter | orderBy: 'Language.Locale'"
         ng-init="localization.Position = $index">
        <div ng-if="!localization.selected"
                ng-click="treeCtrl.editLocalization(localization.Position, vm.item, $event)"
                ng-class="{fade: !localization.Value || !vm.item.Active}">{{localization.Value || 'language.editor.value.missing' | translate}}</div>
        <input class="langEditorInput"
                ng-if="localization.selected"
               type="text" ng-model="localization.Value"
               c-focus="treeCtrl.inputFocused" tabindex="-1"/>
    </div>
    <div class="action-column" ng-if="!treeCtrl.singleValueField">
        <a ng-click="treeCtrl.addAfter(vm.item)">{{'language.editor.add' | translate}}</a>
    </div>
    <div class="action-column" ng-if="treeCtrl.type === 'tree' && vm.item.Active">
        <a ng-click="treeCtrl.addChild(vm.item)">{{'language.editor.addChild' | translate}}</a>
    </div>
    <div class="action-column" ng-if="!treeCtrl.singleValueField && !vm.item.Active">
        <a ng-click="treeCtrl.remove(vm.item, true)">{{'delete' | translate}}</a>
    </div>
    <div class="action-column" ng-if="!treeCtrl.singleValueField && vm.item.Active">
        <a ng-click="treeCtrl.deactivateItem(vm.item)">{{'deactivate' | translate}}</a>
    </div>
    <div class="action-column" ng-if="!treeCtrl.singleValueField && !vm.item.Active">
        <a ng-click="treeCtrl.activateItem(vm.item)">{{'activate' | translate}}</a>
    </div>
    <div class="action-column icon">
        <i class="fa fa-tag" title="{{'fieldoption.id'|translate}}" ng-click="vm.copyId(vm.item.Id)"></i>
    </div>
</div>
<ul><li c-language-editor-node item="child"  ng-repeat="child in vm.item.Children | orderBy: 'Position'" ng-init="treeCtrl.setPosition(item, $index)"></li></ul>
